var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "white",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_7090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3004 8.80022H10.3054C9.28667 8.78618 8.29496 9.12813 7.50137 9.76709C6.70779 10.406 6.16209 11.3019 5.95842 12.3002H1.80042V13.7002H5.95142C6.15152 14.7016 6.69721 15.6008 7.49311 16.2405C8.289 16.8803 9.28445 17.22 10.3054 17.2002H12.3004V8.80022Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1614 12.3004C19.9573 11.2998 19.4096 10.402 18.6131 9.76278C17.8166 9.12355 16.8216 8.7831 15.8004 8.80044H13.7004V17.2004H15.8004C16.8214 17.2202 17.8169 16.8805 18.6127 16.2408C19.4086 15.601 19.9543 14.7018 20.1544 13.7004H24.2004V12.3004H20.1614Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_7090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.2,
    height: 25.2,
    fill: "currentColor",
    transform: "translate(0.400391 0.400391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.9c912ba761cfe7dae0d040359498d17e.svg";
export { ForwardRef as ReactComponent };